<template>
  <LoadingData v-if="isLoadingData" class="my-3" />
  <div v-else class="card-body">
    <div v-if="duplicateOrder.length > 0" class="alert bg-yellow text-dark p-2">
      <strong>Atenção:</strong> As seguintes ordens estão duplicadas:
      {{ formattedDuplicates }}
    </div>
    <h3>{{ survey.presentation }}</h3>
    <div v-for="sf in surveyForms" :key="sf.id">
      <OpenAnswerTextArea
        v-if="sf.componentVue === 'OpenAnswerTextArea'"
        :order="sf.order"
        :freeField1="sf.field1"
        :freeField2="sf.field2"
        :freeField3="sf.field3"
      />
      <ZeroToTenScale
        v-if="sf.componentVue === 'ZeroToTenScale'"
        :order="sf.order"
        :freeField1="sf.field1"
        :freeField2="sf.field2"
        :freeField3="sf.field3"
      />
      <LikertIconsScale
        v-if="sf.componentVue === 'LikertIconsScale'"
        :order="sf.order"
        :freeField1="sf.field1"
        :freeField2="sf.field2"
        :freeField3="sf.field3"
      />
      <SatisfactionScale
        v-if="sf.componentVue === 'SatisfactionScale'"
        :order="sf.order"
        :freeField1="sf.field1"
        :freeField2="sf.field2"
        :freeField3="sf.field3"
      />
      <StarIconsScale
        v-if="sf.componentVue === 'StarIconsScale'"
        :order="sf.order"
        :freeField1="sf.field1"
        :freeField2="sf.field2"
        :freeField3="sf.field3"
      />
      <hr class="mb-4" />
    </div>
    <h3>{{ survey.thanks }}</h3>
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import OpenAnswerTextArea from '@/components/params/forms/OpenAnswerTextArea.vue'
import ZeroToTenScale from '@/components/params/forms/ZeroToTenScale.vue'
import LikertIconsScale from '@/components/params/forms/LikertIconsScale.vue'
import SatisfactionScale from '@/components/params/forms/SatisfactionScale.vue'
import StarIconsScale from '@/components/params/forms/StarIconsScale.vue'

export default {
  name: 'PreviewSurvey',

  props: {
    surveyId: {
      type: String,
      required: true,
    },
  },

  components: {
    LoadingData,
    OpenAnswerTextArea,
    ZeroToTenScale,
    LikertIconsScale,
    SatisfactionScale,
    StarIconsScale,
  },

  data() {
    return {
      isLoadingData: true,
      duplicateOrder: [],
      survey: null,
      surveyForms: [],
    }
  },

  computed: {
    formattedDuplicates() {
      return this.duplicateOrder.join(', ')
    },
  },

  methods: {
    async getSurveyAndSurveyForms() {
      try {
        this.survey = await this.$store.dispatch('getSurvey', this.surveyId)

        this.surveyForms = await this.$store.dispatch('getSurveyForms', {
          surveyId: this.surveyId,
        })

        this.findDuplicates()

        this.isLoadingData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$resf.notification.warning(error.message)
        } else {
          this.$root.$resf.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    findDuplicates() {
      const orders = this.surveyForms.map((sf) => sf.order)

      const duplicates = orders.filter(
        (order, index) => orders.indexOf(order) !== index,
      )

      this.duplicateOrder = [...new Set(duplicates)]
    },
  },

  mounted() {
    this.getSurveyAndSurveyForms()
  },
}
</script>
